import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=2b9372d4&scoped=true&"
import script from "./ArticleList.vue?vue&type=script&lang=ts&"
export * from "./ArticleList.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleList.vue?vue&type=style&index=0&id=2b9372d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9372d4",
  null
  
)

export default component.exports